import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
// import PreMeetingScreen from 'jitsi/base/premeeting/components/web/PreMeetingScreen';
import PreMeetingScreen from 'features/PreMeetingScreen';
import LoadingIndicator from 'jitsi/base/react/components/web/LoadingIndicator';
import Input from 'jitsi/base/ui/components/web/Input';
import { _mapStateToProps } from 'jitsi/lobby/components/AbstractLobbyScreen';
import { LobbyScreen } from 'jitsi/lobby/components/web/LobbyScreen';
import ActionButton from 'features/PreMeetingScreen/ActionButton';
import { withStyles } from '@mui/styles';
import { toggleChat } from 'jitsi/chat/actions.web';
const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    widthLimiter: {
        width: 320,
    },
});
/**
 * Implements a waiting screen that represents the participant being in the lobby.
 */
class IISightLobbyScreen extends LobbyScreen {
    /**
     * Implements {@code PureComponent#render}.
     *
     * @inheritdoc
     */
    render() {
        const { _deviceStatusVisible, showCopyUrlButton, t, showCameraPreview, videoTrack, classes } = this.props;
        return (React.createElement(PreMeetingScreen, { thirdParty: true, className: 'lobby-screen', showDeviceStatus: _deviceStatusVisible, videoMuted: !showCameraPreview, videoTrack: videoTrack, title: t(this._getScreenTitleKey(), { moderator: this.props._lobbyMessageRecipient }) },
            React.createElement("div", { className: classes.container }, this._renderContent())));
    }
    /**
     * Renders the joining (waiting) fragment of the screen.
     *
     * @inheritdoc
     */
    _renderJoining() {
        const { _isLobbyChatActive } = this.props;
        return (React.createElement("div", { className: 'lobby-screen-content' },
            _isLobbyChatActive ? (this._renderLobbyChat()) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'spinner' },
                    React.createElement(LoadingIndicator, { size: 'large' })),
                React.createElement("span", { className: 'joining-message' }, this.props.t('lobby.joiningMessage')))),
            this._renderStandardButtons()));
    }
    /**
     * Renders the widget to chat with the moderator before allowed in.
     *
     * @inheritdoc
     */
    _renderLobbyChat() {
        return React.createElement(React.Fragment, null);
    }
    _onToggleChat() {
        const { dispatch } = this.props;
        return dispatch(toggleChat());
    }
    /**
     * Renders the participant info fragment when we have all the required details of the user.
     *
     * @inheritdoc
     */
    _renderParticipantInfo() {
        const { displayName } = this.state;
        const { _isDisplayNameRequiredActive, t } = this.props;
        const showError = _isDisplayNameRequiredActive && !displayName;
        return (React.createElement(React.Fragment, null,
            React.createElement(Input, { autoFocus: true, className: 'lobby-prejoin-input', error: showError, id: 'lobby-name-field', onChange: this._onChangeDisplayName, placeholder: t('lobby.nameField'), testId: 'lobby.nameField', value: displayName }),
            showError && (React.createElement("div", { className: 'lobby-prejoin-error', "data-testid": 'lobby.errorMessage' }, t('prejoin.errorMissingName')))));
    }
    /**
     * Renders the password form to let the participant join by using a password instead of knocking.
     *
     * @inheritdoc
     */
    _renderPasswordForm() {
        const { _passwordJoinFailed, t, classes } = this.props;
        return (React.createElement("div", { className: classes.widthLimiter },
            React.createElement(Input, { className: `lobby-prejoin-input ${_passwordJoinFailed ? 'error' : ''}`, id: 'lobby-password-input', onChange: this._onChangePassword, placeholder: t('lobby.enterPasswordButton'), testId: 'lobby.password', type: 'password', value: this.state.password }),
            _passwordJoinFailed && (React.createElement("div", { className: 'lobby-prejoin-error', "data-testid": 'lobby.errorMessage' }, t('lobby.invalidPassword')))));
    }
    /**
     * Renders the password join button (set).
     *
     * @inheritdoc
     */
    _renderPasswordJoinButtons() {
        const { classes, t } = this.props;
        return (React.createElement("div", { className: classes.widthLimiter },
            React.createElement(ActionButton, { ariaLabel: t('prejoin.joinMeeting'), className: 'lobby-button-margin', onClick: this._onJoinWithPassword, role: 'button', testId: 'lobby.passwordJoinButton', type: 'primary' }, t('prejoin.joinMeeting')),
            React.createElement(ActionButton, { ariaLabel: t('lobby.backToKnockModeButton'), className: 'lobby-button-margin', onClick: this._onSwitchToKnockMode, role: 'button', testId: 'lobby.backToKnockModeButton', type: 'secondary' }, t('lobby.backToKnockModeButton'))));
    }
    /**
     * Renders the standard button set.
     *
     * @inheritdoc
     */
    _renderStandardButtons() {
        const { _knocking, _isLobbyChatActive, _renderPassword, t, classes } = this.props;
        return (React.createElement("div", { className: classes.widthLimiter },
            _knocking || (React.createElement(ActionButton, { ariaLabel: t('lobby.knockButton'), className: 'lobby-button-margin', onClick: this._onAskToJoin, role: 'button', testId: 'lobby.knockButton', type: 'primary' }, t('lobby.knockButton'))),
            _knocking && _isLobbyChatActive && (React.createElement(ActionButton, { ariaLabel: t('toolbar.openChat'), className: 'lobby-button-margin open-chat-button', onClick: this._onToggleChat, role: 'button', testId: 'toolbar.openChat', type: 'primary' }, t('toolbar.openChat'))),
            _renderPassword && (React.createElement(ActionButton, { ariaLabel: t('prejoin.joinMeeting'), className: 'lobby-button-margin', onClick: this._onSwitchToPasswordMode, role: 'button', testId: 'lobby.enterPasswordButton', type: 'secondary' }, t('lobby.enterPasswordButton')))));
    }
}
export default withStyles(styles)(translate(connect(_mapStateToProps)(IISightLobbyScreen)));
